var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 8.5V51.5h60V8.5H0zm36.625 22.064l-5.446 5.472c-.662.615-1.698.614-2.332.026l-5.473-5.498.048-.047L3.647 10.5h52.719L36.577 30.518l.048.046zm-16.101-.031L2 48.355V11.923l18.524 18.61zm1.41 1.417l5.523 5.549a3.704 3.704 0 002.533.993c.923 0 1.85-.339 2.581-1.02l5.496-5.522L56.304 49.5H3.686l18.248-17.55zm17.543-1.416L58 11.922v36.433L39.477 30.534z"}));
}

Envelope.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = Envelope;

Envelope.default = Envelope;
